import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTableRow
} from '@components/Styles/TableStyle';
import React from 'react';
import CustomInput from '@components/common/Input/CustomInput';
import { CustomStack } from '@components/Styles/CommonStyle';

const CompanyAccountCreateLicense = React.memo(({ param, handleFileChange }) => {

  return (
    <React.Fragment>
        <CustomTableRow>
            <CustomHeaderCell>사업자등록증</CustomHeaderCell>
            <CustomBodyCell>
                <CustomStack>
                    <CustomInput
                    type="file"
                    onChange={handleFileChange}
                    name="businessLicenseFile"
                    sx={{ '& .MuiInputBase-root': { width: 'calc(100% - 68px)' } }}
                    />
                </CustomStack>
                <CustomStack>
                    {/* 사업자등록증 파일 */}
                    {param?.businessLicenseFile &&
                    !(param?.businessLicenseFile instanceof File) &&
                    param?.businessLicenseFile !== '/uploads/null' &&
                    '[현재 파일 : ' + param?.businessLicenseFile + ']'}
                    {param?.businessLicenseFile && param?.businessLicenseFile instanceof File && '[파일 업로드]'}
                </CustomStack>
            </CustomBodyCell>
            <CustomHeaderCell>통장사본</CustomHeaderCell>
            <CustomBodyCell>
                <CustomStack>
                    <CustomInput
                    type="file"
                    onChange={handleFileChange}
                    name="bankbookFile"
                    sx={{ '& .MuiInputBase-root': { width: 'calc(100% - 68px)' } }}
                    />
                </CustomStack>
                <CustomStack>
                    {/* 통장사본 파일 */}
                    {param?.bankbookFile &&
                    !(param?.bankbookFile instanceof File) &&
                    param?.bankbookFile !== '/uploads/null' &&
                    '[현재 파일 : ' + param?.bankbookFile + ']'}
                    {param?.bankbookFile && param?.bankbookFile instanceof File && '[파일 업로드]'}
                </CustomStack>
            </CustomBodyCell>
        </CustomTableRow>
    </React.Fragment>
  );
});

export default CompanyAccountCreateLicense;

